import { audio } from './audio'

const gradients: Map<CanvasRenderingContext2D, {
  horiz: Map<string, CanvasGradient>
  vert: Map<string, CanvasGradient>
}> = new Map()

export class Rms {
  value = 0
  vel = 0
  index = 0
  initial = true
  floats!: Float32Array

  peak = 0
  actual = 0

  update = () => {
    // const db = 20 * Math.log10()
    let float = this.floats[this.index]
    if (float - float !== 0) float = 0

    if (this.initial) {
      this.initial = false
      float = 1
    }
    else if (audio.$.isPlaying) {
      float = Math.max(0, Math.min(1, float))
    }
    else {
      float = 0
    }

    const actual = float ** 0.5
    // const db = 20 * Math.log10(this.floats[this.index])
    // const actual = (100 + db) / 100
    let peak: number
    if (actual > this.value) {
      peak = this.value = actual
      this.vel = 0
    }
    else {
      peak = this.value = this.value + this.vel
      this.vel = this.vel - 0.000127
    }

    this.peak = Math.min(1, peak)
    this.actual = Math.min(1, actual)
  }

  drawHoriz = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number
  ) => {
    const peak = this.peak * w
    const bar = this.actual * w

    try {
      let g = gradients.get(c)
      if (!g) gradients.set(c, g = { horiz: new Map(), vert: new Map() })

      const key = `${x}:${y}:${w}`

      let gradient = g.horiz.get(key)
      if (!gradient) {
        g.horiz.set(
          key,
          gradient = c.createLinearGradient(x, y, x + w, y + h)
        )
        gradient.addColorStop(0, '#26f')
        gradient.addColorStop(0.3, '#2f2')
        gradient.addColorStop(0.6, '#cc1')
        gradient.addColorStop(1, '#f31')
      }
      c.fillStyle = gradient
    } catch { }

    c.fillRect(
      x,
      y,
      bar,
      h
    )

    c.fillRect(
      Math.min(Math.floor(x + w - 1), x + peak),
      y,
      2,
      h
    )
  }

  draw = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number
  ) => {
    const peak = this.peak * h
    const bar = this.actual * h

    try {
      let g = gradients.get(c)
      if (!g) gradients.set(c, g = { horiz: new Map(), vert: new Map() })

      const key = `${x}:${y}:${h}`
      let gradient = g.vert.get(key)
      if (!gradient) {
        g.vert.set(
          key,
          gradient = c.createLinearGradient(x, y, x + 3, y + h)
        )
        gradient.addColorStop(0, '#f31')
        gradient.addColorStop(0.3, '#cc1')
        gradient.addColorStop(0.6, '#2f2')
        gradient.addColorStop(1, '#26f')
      }
      c.fillStyle = gradient
    } catch { }

    c.fillRect(
      x + 1,
      y + (h - bar),
      2,
      bar
    )

    // console.log(float, actual, y, h, y + (h - peak))
    c.fillRect(
      x,
      Math.min(Math.floor(y + h), y + (h - peak)),
      4,
      1
    )
  }
}
